import React, { forwardRef, useState } from 'react';
import DatePickerReact, { ReactDatePickerProps } from 'react-datepicker';
import { CalendarBlank } from 'phosphor-react';
import { ptBR } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

import { DatePickerContainer, DatePickerStyle } from './styles';

type ButtonProps = React.HTMLProps<HTMLButtonElement>;
export type DatePickerFullDateProps = ReactDatePickerProps;

const DatePickerCustomInput = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ value, onClick }, ref) => {
    return (
      <DatePickerContainer
        className="datepicker-custom-input"
        onClick={onClick}
        ref={ref}
        type="button"
      >
        <span className={`${value === '' && 'color-gray-70'}`}>
          {value === '' ? 'dd/mm/aaaa hh:mm' : value}
        </span>
        <div className="calendar">
          <CalendarBlank />
        </div>
      </DatePickerContainer>
    );
  },
);

export const DatePickerFullDate: React.FC<DatePickerFullDateProps> = ({
  ...props
}) => {
  const [selectedDate, useSelectedDate] = useState<Date | null>(new Date());
  return (
    <DatePickerStyle>
      <DatePickerReact
        selected={selectedDate}
        dateFormat="dd/MM/yyyy HH:mm"
        locale={ptBR}
        customInput={<DatePickerCustomInput />}
        showTimeInput
        timeInputLabel="Horário: "
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        {...props}
        maxDate={new Date()}
        onChange={(date) => useSelectedDate(date)}
        shouldCloseOnSelect={false}
      />
    </DatePickerStyle>
  );
};
